import * as React from 'react';

const DoubleSparkleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="#414E71"
      d="M11 8.571A9.272 9.272 0 0 0 15.429 13 9.272 9.272 0 0 0 11 17.429 9.268 9.268 0 0 0 6.57 13 9.268 9.268 0 0 0 11 8.571Zm0-4.553a.995.995 0 0 0-.997.806L9.72 6.151a7.244 7.244 0 0 1-5.57 5.569l-1.326.284c-1.075.23-1.075 1.763 0 1.993l1.327.284A7.244 7.244 0 0 1 9.72 19.85l.284 1.327a.995.995 0 0 0 .997.806.995.995 0 0 0 .997-.806l.284-1.327a7.244 7.244 0 0 1 5.569-5.569l1.327-.284c1.075-.23 1.075-1.763 0-1.993l-1.327-.284a7.244 7.244 0 0 1-5.57-5.569l-.283-1.327A.996.996 0 0 0 11 4.018Zm8.568-1.58.188.679c.152.547.58.975 1.127 1.127l.679.188c.575.16.575.976 0 1.136l-.68.188a1.62 1.62 0 0 0-1.126 1.127l-.188.679c-.16.575-.976.575-1.136 0l-.188-.679a1.62 1.62 0 0 0-1.127-1.127l-.679-.188c-.575-.16-.575-.976 0-1.136l.679-.188a1.62 1.62 0 0 0 1.127-1.127l.188-.679c.16-.575.976-.575 1.136 0Z"
    />
  </svg>
);

export default DoubleSparkleIcon;
